import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CaseEmailInfo, EmailAttachment, GetAttachmentPreview } from '@core/models/case-communication/case-communication-drawer.model';
import { ConstantsService, LayoutService } from '@core/services';
import { CaseCommunicationService } from '@core/services/case-communication.service';
import { LeaveAdminStoreService } from '@core/services/leave-admin-store.service';
import { environment } from '@environments/environment';
import { nameof } from '@shared/helpers';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';
import { indicate } from '@shared/helpers/rxjs.helpers';
import { base64StringToBlob } from 'blob-util';
import { Subject, Observable } from 'rxjs';
import { Editor } from 'tinymce';

@Component({
    selector: 'app-view-email',
    templateUrl: './view-email.component.html',
    styleUrls: ['./view-email.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ViewEmailComponent implements OnInit {
  static readonly componentName = 'ViewEmailComponent';
  
  public isDownloadingAttachment$: Subject<boolean> = new Subject<boolean>();

  public editorStyle: string;

  public position = position;
  public onDragEnded = onDragEnded;
  public tinyMceKey: string;

  private attachmentBeingDownloaded: number = null;

  public isMobile$: Observable<boolean>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      emailData: CaseEmailInfo,
      sysText: any,
      isPreview: boolean
    },
    private layoutService: LayoutService,
    private dialogRef: MatDialogRef<ViewEmailComponent>,
    private constants: ConstantsService,
    private service: CaseCommunicationService,
    private leaveAdminStore: LeaveAdminStoreService
  ) { }

  ngOnInit(): void {
    this.isMobile$ = this.layoutService.isMobile$();

    this.editorStyle = this.constants.EDITOR_STYLES;
    this.tinyMceKey = environment.tinyMceKey;
  }

  public tinySetup(editor: Editor): void {
    editor.mode.set("readonly");
  }

  public close(): void {
    this.dialogRef.close();
  }

  public downloadAttachment(attachment: EmailAttachment): void {
    this.attachmentBeingDownloaded = attachment.attachmentId;

    // not previewing and downloading attachment or previewing and downloading template attachment
    if (!this.data.isPreview || (this.data.isPreview && attachment.isTemplateFile)) {
      this.service.getAttachment({
          caseId: this.leaveAdminStore.caseDetails.leaveInformation.caseId,
          attachmentId: attachment.attachmentId,
          isDocument: attachment.isDocument,
          isPreview: this.data.isPreview
        })
        .pipe(indicate(this.isDownloadingAttachment$))
        .subscribe(res => {
          var newBlob = base64StringToBlob(res.fileBytes, res.mimeType);
          var url = window.URL.createObjectURL(newBlob);
      
          var win = window.open(url, '_blank');
  
          win.onload = () => { this.attachmentBeingDownloaded = null; };
        });
    }
    // otherwise previewing an attachment uploaded on the fly
    else if (this.data.isPreview && attachment.file){
      const formData = new FormData();
      formData.append(nameof<GetAttachmentPreview>('caseId'), this.leaveAdminStore.caseDetails.leaveInformation.caseId.toString());
      formData.append(attachment.attachmentTitle, attachment.file);

      this.service.getAttachmentPreview(formData)
        .pipe(indicate(this.isDownloadingAttachment$))
        .subscribe(res => {
          var newBlob = base64StringToBlob(res.fileBytes, res.mimeType);
          var url = window.URL.createObjectURL(newBlob);
      
          var win = window.open(url, '_blank');

          win.onload = () => { this.attachmentBeingDownloaded = null; };
        });
    }

  }
  
  public isDownloadingAttachment (attachmentId: number): boolean {
    return attachmentId == this.attachmentBeingDownloaded;
  }
}